<template>
    <nav class="episodes-list-nav">
        <ul class="nav-items">
            <episodes-list-nav-item
                v-for="(item, key) in items"
                :key="key"
                v-model="status"
                :icon="item.icon"
                :status="item.value"
            >
                {{ item.label }} ({{ episodesCount[key] || 0 }})
            </episodes-list-nav-item>
        </ul>
    </nav>
</template>
<script>
import EpisodesListNavItem from './EpisodesListNavItem';

const DEFAULT_ITEM = null;

export default {
    components: {
        EpisodesListNavItem,
    },

    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        value: {
            type: String,
            default: null,
        },

        episodesCount: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        items: {
            any: {
                icon: 'volume-up',
                label: 'All Episodes',
                value: null,
            },
            published: {
                icon: 'check-circle',
                label: 'Published',
                value: 'published',
            },
            scheduled: {
                icon: 'calendar-alt',
                label: 'Scheduled',
                value: 'scheduled',
            },
            unpublished: {
                icon: 'pen',
                label: 'Draft',
                value: 'unpublished',
            },
        },
    }),

    computed: {
        status: {
            /**
             * Gets value of status.
             *
             * @returns {string|null} Schedule value.
             */
            get() {
                return this.value || DEFAULT_ITEM;
            },

            /**
             * Sets value of status.
             *
             * @param {string|null} value Schedule value.
             */
            set(value) {
                this.$emit('change', value);
            },
        },
    },
};
</script>
